import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import { Chip } from '@mui/material';
import type { WorkspaceRelation } from '@shared/dto/auth/membership-search.response.dto';
import { useTranslation } from 'react-i18next';

interface WorkspaceRelationChipProps {
  workspaceRelation: WorkspaceRelation;
}

/**
 * Dice al consulente quale, tra le sue aziende, è il suo studio e quale è
 * l'azienda del suo partner: sono le due righe da cui parte il lavoro di ogni
 * giorno, a differenza dei clienti.
 */
export function WorkspaceRelationChip({ workspaceRelation }: WorkspaceRelationChipProps) {
  const { t } = useTranslation();
  const Icon =
    workspaceRelation === 'PARTNER_STUDIO' ? BusinessCenterOutlinedIcon : ApartmentOutlinedIcon;

  return (
    <Chip
      icon={<Icon aria-hidden />}
      label={t(`consultant.companyPicker.workspaceRelation.${workspaceRelation}`)}
      size="small"
      color="info"
      variant="outlined"
      sx={{
        flexShrink: 0,
        height: 22,
        fontSize: '0.7rem',
        fontWeight: 600,
        color: (theme) => theme.palette.info.dark,
        '& .MuiChip-icon': { fontSize: 14, color: 'inherit' },
      }}
    />
  );
}
